import { ActionGenerator, actionsGenerator } from 'store/utils';

export const GET_ORGANIZATIONS = '@ORGANIZATIONS/GET';

export const GET_ORGANIZATIONS_ACTIONS: ActionGenerator = actionsGenerator(
  GET_ORGANIZATIONS,
);
